import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { onlyNumbers } from 'src/app/core/utils/patterns';

@Component({
  selector: 'adp-verify-code',
  templateUrl: './verify-code.component.html',
  styleUrl: './verify-code.component.scss'
})
export class VerifyCodeComponent {
  step2Form: FormGroup;
  @Output() verifyCode: EventEmitter<string> = new EventEmitter<string>();

  constructor(private fb: FormBuilder) {
    this.step2Form = this.fb.group({
      digit1: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      digit2: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      digit3: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      digit4: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      digit5: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      digit6: ['', [Validators.required, Validators.pattern(/^\d$/)]],
    });
  }

  ngOnInit(): void {}

  onDigitInput(event: any, nextInput: string, prevInput: string) {
    const input = event.target;
    let value = input.value;

    value = value.replace(/[^0-9]/g, '');
    
    if (value.length > 1) {
      value = value.charAt(value.length - 1);
    }

    input.value = value;

    const controlName = input.getAttribute('formControlName');
    if (controlName) {
      this.step2Form.get(controlName)?.setValue(value);
      
      Object.keys(this.step2Form.controls).forEach(key => {
        this.step2Form.get(key)?.markAsTouched();
      });
    }

    if (value && nextInput) {
      const next = document.getElementById(nextInput) as HTMLInputElement;
      if (next) {
        next.focus();
        next.select();
      }
    }

    // Emitir el código automáticamente cuando esté completo
    if (this.step2Form.valid) {
      this.onVerify();
    }
  }

  onKeyDown(event: KeyboardEvent, nextInput: string, prevInput: string) {
    // console.log(event.key);
    
    const input = event.target as HTMLInputElement;

     if ((event.key === ' ' || event.key === 'Spacebar') && !input.value) {
      event.preventDefault();
      if (nextInput) {
        const next = document.getElementById(nextInput) as HTMLInputElement;
        if (next) {
          next.focus();
          next.select();
        }
      }
      return;
    }

    if (event.key === 'ArrowLeft' && prevInput) {
      event.preventDefault();
      const prev = document.getElementById(prevInput) as HTMLInputElement;
      if (prev) {
        prev.focus();
        prev.select();
      }
      return;
    }

    if (event.key === 'ArrowRight' && nextInput) {
      event.preventDefault();
      const next = document.getElementById(nextInput) as HTMLInputElement;
      if (next) {
        next.focus();
        next.select();
      }
      return;
    }

    if (event.key === 'Backspace') {
      event.preventDefault();
      
      if (input.value) {
        input.value = '';
        const controlName = input.getAttribute('formControlName');
        if (controlName) {
          this.step2Form.get(controlName)?.setValue('');
        }
      } else if (prevInput) {
        const prev = document.getElementById(prevInput) as HTMLInputElement;
        if (prev) {
          prev.focus();
          prev.select();
        }
      }
    }

    if (event.key.length === 1 && !/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }

  onFocus(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    input.select();
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text');
    const cleanData = pastedData.replace(/\s+/g, '');
    if (cleanData && /^\d{6}$/.test(cleanData)) {
      const activeElement = document.activeElement;
      
      const digits = cleanData.split('');
      this.step2Form.patchValue({
        digit1: digits[0],
        digit2: digits[1],
        digit3: digits[2],
        digit4: digits[3],
        digit5: digits[4],
        digit6: digits[5],
      });

      Object.keys(this.step2Form.controls).forEach(key => {
        this.step2Form.get(key)?.markAsTouched();
      });
      
      if (activeElement instanceof HTMLElement) {
        activeElement.blur();
      }

      setTimeout(() => {
        if (document.activeElement instanceof HTMLInputElement) {
          document.activeElement.blur();
        }
        // Emitir el código automáticamente después de pegar
        if (this.step2Form.valid) {
          this.onVerify();
        }
      }, 0);
    }
  }

  getVerificationCode(): string {
    return Object.values(this.step2Form.value).join('');
  }

  onVerify(): void {
    this.verifyCode.emit(this.getVerificationCode());
  }

  isFormValid(): boolean {
    return this.step2Form.valid;
  }

  hasError(): boolean {
    const isTouched = Object.keys(this.step2Form.controls).some(key => 
      this.step2Form.get(key)?.touched
    );
    
    if (this.step2Form.invalid && isTouched) {
      Object.keys(this.step2Form.controls).forEach(key => {
        this.step2Form.get(key)?.markAsTouched();
      });
      return true;
    }
    return false;
    // return this.step2Form.invalid && this.step2Form.touched;
  }
}
